<div class="form-group">
  <label for="member">Member</label>

  <select class="custom-select"
          id="member" name="member"
          [(ngModel)]="member">
    <option *ngFor="let member of getActionableMembers()"
            [ngValue]="member">
      {{ member.first_name }} {{ member.last_name }}
    </option>
  </select>
</div>

<div class="form-group">
  <label>Effective Date</label>

  <div class="form-check" *ngFor="let upcomingBillDate of membership.upcoming_bill_dates">
    <input class="form-check-input" type="radio"
           name="effectiveDate" id="effectiveDate{{ upcomingBillDate }}"
           [(ngModel)]="effectiveDate" (ngModelChange)="updateEffectiveDaysFromNow()"
           [value]="upcomingBillDate">
    <label class="form-check-label" for="effectiveDate{{ upcomingBillDate }}">
      {{ dateStringFromISO8601(upcomingBillDate) }}
    </label>
  </div>
</div>

<div class="form-group" *ngIf="effectiveDate">
  <label>Unfreeze Date (optional)</label>

  <div class="form-check">
    <input class="form-check-input" type="radio"
           name="unfreezeDate" id="unfreezeDateNone"
           [(ngModel)]="unfreezeDate"
           [value]="null">
    <label class="form-check-label" for="unfreezeDateNone">
      None (set unfreeze date later)
    </label>
  </div>
  <div class="form-check" *ngFor="let upcomingBillDate of getPossibleUnfreezeDates()">
    <input class="form-check-input" type="radio"
           name="unfreezeDate" id="unfreezeDate{{ upcomingBillDate }}"
           [(ngModel)]="unfreezeDate"
           [value]="upcomingBillDate">
    <label class="form-check-label" for="unfreezeDate{{ upcomingBillDate }}">
      {{ dateStringFromISO8601(upcomingBillDate) }}
    </label>
  </div>
</div>

<div class="form-group" *ngIf="orgConfigService.getOrganizationConfig().require_membership_freeze_reason">
  <label for="reasonSelect">Freeze Reason</label>
  <select class="custom-select"
          name="reason" id="reasonSelect"
          [(ngModel)]="reason">
    <option [ngValue]="null" disabled>---</option>
    <option *ngFor="let reasonOption of orgConfigService.getOrganizationConfig().membership_freeze_reason_options"
            [ngValue]="reasonOption">{{ reasonOption }}</option>
  </select>
</div>

<div class="alert alert-warning" *ngIf="effectiveDaysFromNow && (effectiveDaysFromNow > 30)">
  Your chosen effective date is {{ effectiveDaysFromNow }} days in the future. Please double check that this is correct before submitting.
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
